export default __webpack_public_path__ + "static/media/submarine.48c9704c.png";